export default __webpack_public_path__ + "static/media/baxterRenalWhite.5988cf0f.png";